import { IconMoon } from '@tabler/icons-react-native';
import { canChangeAppTheme } from 'app/components/app/app-theme-policy';
import { Row } from 'app/design/primitives/box';
import { Switch } from 'app/design/primitives/switch';
import { Text } from 'app/design/primitives/text';
import { useTheme, useThemeMode } from 'app/shopify/theme';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useUISize } from 'app/utils/web-helpers';
import { useTranslation } from 'react-i18next';

export function ThemeModeSwitch() {
  const { t } = useTranslation('profile-overview');
  const theme = useTheme();
  const { isDark, setMode } = useThemeMode();
  const { isLargeUI } = useUISize();
  const label = t('darkModeLabel');

  if (!canChangeAppTheme()) return null;

  return (
    <Row
      alignItems="center"
      backgroundColor={isLargeUI ? undefined : 'surface.primary-neutral'}
      borderRadius="radius.xl"
      gap="spacing.general.x3"
      marginTop="spacing.general.x4"
      padding="spacing.general.x4"
    >
      <IconMoon color={theme.colors['icon.primary']} size={32} strokeWidth={ICON_STROKE_WIDTH} />
      <Text flex={1}>{label}</Text>
      <Switch accessibilityLabel={label} value={isDark} onValueChange={(dark) => setMode(dark ? 'dark' : 'light')} />
    </Row>
  );
}
